'use client'

import { useState } from 'react'
import { UpdatesDateSidebar } from './updates-date-sidebar'
import { UpdatesContent, type Update } from './updates-content'

const UPDATES: Update[] = [
    {
        date: 'January 21, 2025',
        label: 'Update',
        title: 'Add your portfolio to Insighthread manually.',
        description:
            "In the coming weeks, we'll add call transcripts, AI-powered transcript summaries, and presentation slides—committing to deliver the best earnings experience in the world.",
        items: [
            'New route group structure for better organization',
            'Page-specific metadata and Open Graph tags',
            'Structured data implementation for better search visibility',
            'Improved navigation and footer components',
        ],
    },
    {
        date: 'February 20, 2025',
        label: 'Update',
        title: 'Enhanced AI Stock Analysis',
        description:
            "We've significantly improved our AI analysis engine to provide deeper insights into stock performance and market trends.",
        items: [
            'Advanced sentiment analysis from news articles',
            'Real-time market correlation detection',
            'Improved earnings prediction accuracy',
            'Enhanced technical indicators',
        ],
    },
    {
        date: 'May 27, 2025',
        label: 'Feature',
        title: 'Smart Watchlist Management',
        description:
            'Introducing our new Smart Watchlist feature that automatically categorizes and tracks your favorite stocks with intelligent alerts.',
        items: [
            'Auto-categorization based on sectors and performance',
            'Custom alert triggers for price movements',
            'Portfolio diversity analysis',
            'Performance comparison tools',
        ],
    },
    {
        date: 'May 28, 2025',
        label: 'Update',
        title: 'Real-time Market Data Integration',
        description:
            "We've integrated real-time market data feeds to ensure you always have the most up-to-date information at your fingertips.",
        items: [
            'Live price updates with minimal latency',
            'Real-time volume and trading activity',
            'Instant earnings call notifications',
            'Pre-market and after-hours tracking',
        ],
    },
    {
        date: 'June 6, 2025',
        label: 'Feature',
        title: 'Advanced Charting Tools',
        description:
            'New interactive charting capabilities with advanced technical analysis tools and customizable indicators.',
        items: [
            'Multiple chart types (candlestick, line, area)',
            'Over 50 technical indicators',
            'Custom drawing tools and annotations',
            'Compare multiple stocks simultaneously',
        ],
    },
    {
        date: 'June 17, 2025',
        label: 'Update',
        title: 'Mobile App Launch',
        description:
            'Insighthread is now available on iOS and Android! Access all your favorite features on the go with our native mobile applications.',
        items: [
            'Native iOS and Android applications',
            'Push notifications for important updates',
            'Optimized mobile interface',
            'Offline mode for saved data',
        ],
    },
    {
        date: 'June 26, 2025',
        label: 'Feature',
        title: 'AI-Powered News Aggregation',
        description:
            'Our new AI news engine automatically curates and summarizes the most relevant market news and company announcements for your watchlist.',
        items: [
            'Personalized news feed based on your interests',
            'AI-generated summaries for quick insights',
            'Sentiment analysis for each news article',
            'Breaking news alerts with market impact predictions',
        ],
    },
    {
        date: 'August 27, 2025',
        label: 'Update',
        title: 'Enhanced Portfolio Analytics',
        description:
            'Track your investment performance with our comprehensive portfolio analytics dashboard featuring advanced metrics and visualizations.',
        items: [
            'Portfolio performance tracking with detailed metrics',
            'Risk assessment and diversification analysis',
            'Tax-loss harvesting suggestions',
            'Benchmark comparison against major indices',
        ],
    },
    {
        date: 'September 15, 2025',
        label: 'Feature',
        title: 'Social Trading Community',
        description:
            'Connect with other investors, share insights, and learn from top performers in our new social trading platform.',
        items: [
            'Follow successful traders and their strategies',
            'Share your analysis and get community feedback',
            'Discussion forums for specific stocks and sectors',
            'Copy trading feature for premium members',
        ],
    },
    {
        date: 'October 3, 2025',
        label: 'Update',
        title: 'Options Trading Analytics',
        description:
            'Advanced options analytics tools to help you identify opportunities and manage risk in your options trading strategy.',
        items: [
            'Options chain with Greeks and implied volatility',
            'Probability calculator for various strategies',
            'Options flow detection and unusual activity alerts',
            'Strategy builder with profit/loss visualization',
        ],
    },
    {
        date: 'October 18, 2025',
        label: 'Feature',
        title: 'AI Investment Assistant',
        description:
            'Meet your personal AI investment assistant that provides tailored recommendations and answers your market-related questions in real-time.',
        items: [
            'Natural language queries about stocks and markets',
            'Personalized investment recommendations',
            'Risk-adjusted portfolio suggestions',
            'Market trend analysis and forecasting',
        ],
    },
]

export function UpdatesContainer() {
    const dates = UPDATES.map((u) => u.date)
    const [selectedDate, setSelectedDate] = useState(dates[0] || '')

    return (
        <div className="grid grid-cols-[240px_1fr] gap-12 max-w-6xl mx-auto">
            <UpdatesDateSidebar
                dates={dates}
                selectedDate={selectedDate}
                onDateSelect={setSelectedDate}
            />
            <UpdatesContent updates={UPDATES} selectedDate={selectedDate} />
        </div>
    )
}
